import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "timer",
  "use": "timer-usage",
  "viewBox": "0 0 20 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 20 22\" id=\"timer\"><path d=\"M11 22a9 9 0 1 1 0-18 9 9 0 0 1 0 18zm0-2a7 7 0 1 0 0-14 7 7 0 0 0 0 14z\" /><path d=\"M9.99 0h2.019a1 1 0 0 1 .977 1.21L12.17 5H9.867l-.852-3.78A1 1 0 0 1 9.991 0zM.544 6.87l.537-.711a1 1 0 0 1 1.586-.015l1.75 2.234-.857 1.138L.947 8.39a1 1 0 0 1-.403-1.52zM11.387 11.524l2.522-2.018a.5.5 0 0 1 .702.703l-2.015 2.519a1.5 1.5 0 1 1-1.21-1.204z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol